import { render, staticRenderFns } from "./TableNotFound.vue?vue&type=template&id=58abb3cf&scoped=true&lang=html"
import script from "./TableNotFound.vue?vue&type=script&lang=js"
export * from "./TableNotFound.vue?vue&type=script&lang=js"
import style0 from "./TableNotFound.vue?vue&type=style&index=0&id=58abb3cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58abb3cf",
  null
  
)

export default component.exports